// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ce963b00","453":"74368154","455":"3e678723","977":"92dea5b1"}[chunkId] + ".chunk.js";
};